import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { companiesService } from '../api/companies.service';

/** Tab counts for companies list (active / trash / archive). */
export function useCompanyStatsQuery() {
  const active = useQuery({
    queryKey: [...queryKeys.companies.stats(), 'active'],
    queryFn: () => companiesService.list({ page: 1, limit: 1, includeDeleted: false }),
    staleTime: 60_000,
  });
  const trash = useQuery({
    queryKey: [...queryKeys.companies.stats(), 'trash'],
    queryFn: () => companiesService.list({ page: 1, limit: 1, includeDeleted: true, includePurged: false }),
    staleTime: 60_000,
  });
  const archive = useQuery({
    queryKey: [...queryKeys.companies.stats(), 'archive'],
    queryFn: () => companiesService.list({ page: 1, limit: 1, includeDeleted: true, includePurged: true }),
    staleTime: 60_000,
  });

  return {
    stats: {
      active: active.data?.pagination.total ?? 0,
      trash: trash.data?.pagination.total ?? 0,
      archive: archive.data?.pagination.total ?? 0,
    },
    isLoading: active.isLoading || trash.isLoading || archive.isLoading,
    isError: active.isError || trash.isError || archive.isError,
  };
}
